import React, { useState, useEffect } from 'react';
import { Table, Dimmer, Segment, Loader, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { iRootState } from '../../../../store';
import IconButton from '../../../../components/IconButton';
import { ClickableTableCell, SelectableTableRow } from '../../../../styles';
import { MasterFranchiseState } from '../../../../types/FranchiseState';
import { maskCpfOrCnpj, maskPhoneNumber } from '../../../../services/masks';
import { Header, NotFoundWrapper, TableComponent, TableWrapper } from './styles';
import AuthorizationContainer from '../../../../components/AuthorizationContainer';
import { FeatureEnum } from '../../../../enums/authz-feature.enum';
import { ActionEnum } from '../../../../enums/authz-action.enum';
import { useHistory } from 'react-router-dom';
import { statusOptions } from '../../types';
import TablePaginationMenu from '../../../../components/TablePaginationMenu';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapState = (state: iRootState) => ({
  user: state.user,
  availableBrokersAndEstates: state.availableBrokersAndEstates
});

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatch = () => ({});

type Props = {
  multiFranchises: MasterFranchiseState[] | [];
  isLoading: boolean;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  dataCount: number;
  handleSelectItem: (multiFranchise: MasterFranchiseState) => void;
} & ReturnType<typeof mapState>;

const MasterFranchiseListPageTable = (props: Props): JSX.Element => {
  const {
    multiFranchises,
    isLoading,
    currentPage,
    setCurrentPage,
    dataCount,
    handleSelectItem
  } = props;

  const [listData, setListData] = useState<MasterFranchiseState[]>([]);
  const history = useHistory();

  useEffect(() => {
    setListData(multiFranchises);
  }, [multiFranchises]);

  function renderTableData(
    multiFranchises: Array<MasterFranchiseState>
  ): Array<JSX.Element> {
    const trigger = (
      <AuthorizationContainer action={ActionEnum.update} feature={FeatureEnum.policies}>
        <IconButton name="ellipsis vertical" />
      </AuthorizationContainer>
    );
    return multiFranchises.map((multiFranchise: MasterFranchiseState) => {
      return (
        <SelectableTableRow key={multiFranchise?.id}>
          <ClickableTableCell onClick={() => handleSelectItem(multiFranchise)}>
            {multiFranchise?.responsible_name}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(multiFranchise)}>
            {maskPhoneNumber(multiFranchise?.responsible_phone)}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(multiFranchise)}>
            {multiFranchise?.responsible_email}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(multiFranchise)}>
            {statusOptions.find(status => status.value === multiFranchise?.status)?.text}
          </ClickableTableCell>

          <ClickableTableCell width={1} textAlign={'right'}>
            <Dropdown trigger={trigger} icon={null} direction="left">
              <Dropdown.Menu>
                <Dropdown.Item
                  icon="pencil"
                  text={'Editar Parceiro'}
                  onClick={() =>
                    history.push(`/admin/franchise/${multiFranchise?.id}?type=multi`)
                  }
                />
              </Dropdown.Menu>
            </Dropdown>
          </ClickableTableCell>
        </SelectableTableRow>
      );
    });
  }

  return (
    <TableComponent>
      <Dimmer.Dimmable as={Segment} dimmed={isLoading}>
        <Dimmer active={isLoading} inverted>
          <Loader />
        </Dimmer>
        {listData && listData.length > 0 ? (
          <TableWrapper>
            <Table>
              <Header>
                <Table.Row>
                  <Table.HeaderCell>NOME RESPONSÁVEL</Table.HeaderCell>
                  <Table.HeaderCell> CONTATO </Table.HeaderCell>
                  <Table.HeaderCell>EMAIL</Table.HeaderCell>
                  <Table.HeaderCell>STATUS</Table.HeaderCell>
                  <Table.HeaderCell width={1} textAlign={'right'}>
                    <IconButton name="setting" />
                  </Table.HeaderCell>
                </Table.Row>
              </Header>
              <Table.Body>{renderTableData(multiFranchises)}</Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="17">
                    <TablePaginationMenu
                      currentPage={currentPage}
                      dataCount={dataCount}
                      setCurrentPage={setCurrentPage}
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </TableWrapper>
        ) : (
          <NotFoundWrapper>
            <p>Parceiros não encontrados</p>
          </NotFoundWrapper>
        )}
      </Dimmer.Dimmable>
    </TableComponent>
  );
};

export default connect(mapState, mapDispatch)(MasterFranchiseListPageTable);
